import shellHttpClient from '@/shells/api/shellHttpClient';
import { normalizeInterfacePreferences, serializePreferencePatch } from '@/shells/models/interfacePreferences';

export class InterfacePreferencesRepository {
  constructor(client = shellHttpClient) {
    this.client = client;
  }

  async get() {
    // Also read from classic pages: their CORS contract permits authorization
    // and content-type, but not the preview client's optional AJAX marker.
    const response = await this.client.get('/api/v1/users/interface-preferences', { headers: { 'X-Requested-With': undefined } });
    return normalizeInterfacePreferences(response.data);
  }

  async update(patch) {
    const response = await this.client.put(
      '/api/v1/users/interface-preferences',
      serializePreferencePatch(patch),
      { headers: { 'Content-Type': 'application/json', 'X-Requested-With': undefined } }
    );
    return normalizeInterfacePreferences(response.data);
  }
}

export const interfacePreferencesRepository = new InterfacePreferencesRepository();
